import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const GenerateToken = ({ open, onClose, token }) => {
  const CopyToClipboard = (containerid) => {
    let range = null;
    if (document.selection) {
      range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select().createTextRange();
      document.execCommand("copy");
    } else if (window.getSelection) {
      range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().addRange(range);
      document.execCommand("copy");
      toast.success("Coppied");
    }
  }

  return (
    <Modal zIndex={2000} size={"xl"} centered isOpen={open} toggle={onClose}>
      <ModalHeader toggle={onClose}>Generated Token</ModalHeader>
      <ModalBody>
        <div id="div1" style={{ wordBreak: "break-word" }}>
          {token}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            CopyToClipboard("div1");
          }}>
          Copy
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GenerateToken;

GenerateToken.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  token: PropTypes.string.isRequired,
  setGenerateModal: PropTypes.func
};
